/* ============================================================
   LOUIS BAYRAD Header — louis-header.js
   Announcement rotation · Transparent scroll detection
   Mobile menu toggle · Cart count sync
   ============================================================ */

(function () {
  'use strict';

  // ─── Announcement Bar Rotation ──────────────────────────
  var slides = document.querySelectorAll('.louis-topbar-slide');

  if (slides.length > 1) {
    var currentSlide = 0;
    slides[0].classList.add('active');

    setInterval(function () {
      // kick the current slide out upward
      var leaving = slides[currentSlide];
      leaving.classList.remove('active');
      leaving.classList.add('exiting');

      // once the exit transition finishes, reset it below the bar (ready for next cycle)
      leaving.addEventListener('transitionend', function resetSlide() {
        leaving.classList.remove('exiting');
        leaving.removeEventListener('transitionend', resetSlide);
      });

      // roll the next slide in from below
      currentSlide = (currentSlide + 1) % slides.length;
      slides[currentSlide].classList.add('active');
    }, 4000);

  } else if (slides.length === 1) {
    slides[0].classList.add('active');
  }

  // ─── Transparent Header: Scroll Detection ───────────────
  var header = document.getElementById('louis-header');

  if (header && header.dataset.transparent === 'true') {
    function onScroll() {
      if (window.scrollY > 60) {
        header.classList.add('louis-scrolled');
      } else {
        header.classList.remove('louis-scrolled');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // run on load in case page is already scrolled
  }

  // ─── Mobile Menu Toggle ──────────────────────────────────
  var hamburger = document.querySelector('.louis-hamburger');
  var mobilePanel = document.getElementById('louis-mobile-menu');

  if (hamburger) {
    hamburger.addEventListener('click', function () {
      var isOpen = document.body.classList.toggle('louis-menu-open');
      hamburger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (mobilePanel) {
        mobilePanel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      }
    });
  }

  // Close mobile menu on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains('louis-menu-open')) {
      document.body.classList.remove('louis-menu-open');
      if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
      if (mobilePanel) mobilePanel.setAttribute('aria-hidden', 'true');
    }
  });

  // Close mobile menu when a link is clicked
  if (mobilePanel) {
    mobilePanel.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') {
        document.body.classList.remove('louis-menu-open');
        if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
        mobilePanel.setAttribute('aria-hidden', 'true');
      }
    });
  }

  // ─── Wishlist Count Badge ────────────────────────────────
  var WL_KEY = 'tenhem_wishlist';

  function updateWishlistCount() {
    try {
      var raw = JSON.parse(localStorage.getItem(WL_KEY)) || [];
      // Only count valid product objects (filter out stale string-format entries)
      var count = raw.filter(function (p) {
        return p && typeof p === 'object' && p.id && p.title && p.title !== 'undefined';
      }).length;

      var badge = document.getElementById('louis-wl-count');
      if (!badge) return;
      if (count > 0) {
        badge.textContent = count;
        badge.style.display = 'flex';
      } else {
        badge.style.display = 'none';
      }
    } catch (e) {}
  }

  updateWishlistCount();

  // Re-sync when another tab or page updates the wishlist
  window.addEventListener('storage', function (e) {
    if (e.key === WL_KEY) updateWishlistCount();
  });

  // Re-sync when wishlist changes on THIS page (PDP / PLP fire this event)
  window.addEventListener('tenhem:wishlist:updated', updateWishlistCount);

  // ─── Cart Count Sync ─────────────────────────────────────
  function updateCartCount() {
    fetch('/cart.js', { method: 'GET', headers: { 'Content-Type': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var count = cart.item_count || 0;
        var badges = document.querySelectorAll('.louis-bag-count');
        badges.forEach(function (el) {
          el.textContent = count;
          el.style.display = count > 0 ? 'flex' : 'none';
        });
      })
      .catch(function () {});
  }

  updateCartCount();

  // Listen for add-to-cart events dispatched by louis-pdp.js
  document.addEventListener('tenhem:cart:updated', updateCartCount);

  // Also listen for Shopify's native cart:refresh event (used by some apps)
  document.addEventListener('cart:refresh', updateCartCount);

  // ─── Cart Drawer ─────────────────────────────────────
  // Move drawer + backdrop to <body> so Shopify's section wrapper transforms
  // don't break position:fixed (a transformed ancestor breaks fixed positioning)
  function setupCartDrawer() {
    var drawerEl   = document.getElementById('louis-cart-drawer');
    var backdropEl = document.getElementById('louis-drawer-backdrop');
    if (drawerEl   && drawerEl.parentElement   !== document.body) document.body.appendChild(drawerEl);
    if (backdropEl && backdropEl.parentElement !== document.body) document.body.appendChild(backdropEl);
    initCartDrawer();
  }

  // DOMContentLoaded may have already fired if script loads at end of body
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupCartDrawer);
  } else {
    setupCartDrawer();
  }

  function initCartDrawer() {
  var drawer   = document.getElementById('louis-cart-drawer');
  var backdrop = document.getElementById('louis-drawer-backdrop');
  var trigger  = document.getElementById('louis-cart-trigger');
  var closeBtn = document.getElementById('louis-drawer-close');
  var drawerBody     = document.getElementById('louis-drawer-body');
  var drawerItems    = document.getElementById('louis-drawer-items');
  var drawerEmpty    = document.getElementById('louis-drawer-empty');
  var drawerFoot     = document.getElementById('louis-drawer-foot');
  var drawerCount    = document.getElementById('louis-drawer-count');
  var drawerSubtotal = document.getElementById('louis-drawer-subtotal');

  function formatMoney(cents) {
    return 'Rs. ' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    backdrop.classList.add('is-open');
    document.body.classList.add('louis-drawer-open');
    drawer.setAttribute('aria-hidden', 'false');
    backdrop.setAttribute('aria-hidden', 'false');
    loadDrawerCart();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    document.body.classList.remove('louis-drawer-open');
    drawer.setAttribute('aria-hidden', 'true');
    backdrop.setAttribute('aria-hidden', 'true');
  }

  function loadDrawerCart() {
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderDrawer(cart);
      })
      .catch(function () {});
  }

  function renderDrawer(cart) {
    var count = cart.item_count || 0;

    // Update badge counts everywhere
    document.querySelectorAll('.louis-bag-count').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });

    // Update drawer head count
    if (drawerCount) drawerCount.textContent = count;

    // Empty vs filled state
    if (count === 0) {
      if (drawerItems) drawerItems.innerHTML = '';
      if (drawerEmpty) drawerEmpty.style.display = 'flex';
      if (drawerFoot)  drawerFoot.hidden = true;
      return;
    }

    if (drawerEmpty) drawerEmpty.style.display = 'none';
    if (drawerFoot)  drawerFoot.hidden = false;

    // Subtotal
    if (drawerSubtotal) drawerSubtotal.textContent = formatMoney(cart.total_price);

    // Render items
    if (!drawerItems) return;
    drawerItems.innerHTML = '';
    cart.items.forEach(function (item) {
      var li = document.createElement('li');
      li.className = 'louis-drawer-item';
      li.dataset.lineKey = item.key;

      var imgSrc  = item.image ? item.image.replace('.jpg', '_160x.jpg').replace('.png', '_160x.png').replace('.webp', '_160x.webp') : '';
      var imgTag  = imgSrc
        ? '<img class="louis-drawer-item-img" src="' + imgSrc + '" alt="' + item.title.replace(/"/g, '') + '" loading="lazy">'
        : '<div class="louis-drawer-item-img" style="background:#f5f2eb;"></div>';

      var variantLabel = item.variant_title && item.variant_title !== 'Default Title'
        ? item.variant_title
        : '';

      var priceHtml = '';
      if (item.original_line_price !== item.final_line_price) {
        priceHtml = '<s>' + formatMoney(item.original_line_price) + '</s>'
                  + '<span class="sale">' + formatMoney(item.final_line_price) + '</span>';
      } else {
        priceHtml = formatMoney(item.final_line_price);
      }

      li.innerHTML =
        imgTag +
        '<div class="louis-drawer-item-info">' +
          '<a href="' + item.url + '" class="louis-drawer-item-name">' + item.product_title + '</a>' +
          (variantLabel ? '<p class="louis-drawer-item-variant">' + variantLabel + '</p>' : '') +
          '<p class="louis-drawer-item-price">' + priceHtml + '</p>' +
          '<div class="louis-drawer-item-qty">' +
            '<button class="louis-drawer-qty-btn" data-action="minus" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Decrease quantity">−</button>' +
            '<span class="louis-drawer-qty-num">' + item.quantity + '</span>' +
            '<button class="louis-drawer-qty-btn" data-action="plus" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Increase quantity">+</button>' +
          '</div>' +
        '</div>' +
        '<button class="louis-drawer-remove" data-key="' + item.key + '" aria-label="Remove item">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
            '<polyline points="3 6 5 6 21 6"/>' +
            '<path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>' +
          '</svg>' +
        '</button>';

      drawerItems.appendChild(li);
    });

    // Qty + remove button handlers
    drawerItems.querySelectorAll('.louis-drawer-qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key    = this.dataset.key;
        var action = this.dataset.action;
        var qty    = parseInt(this.dataset.qty, 10);
        var newQty = action === 'plus' ? qty + 1 : Math.max(0, qty - 1);
        updateLineItem(key, newQty);
      });
    });

    drawerItems.querySelectorAll('.louis-drawer-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        updateLineItem(this.dataset.key, 0);
      });
    });
  }

  function updateLineItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderDrawer(cart);
        // Keep header count in sync
        document.dispatchEvent(new CustomEvent('tenhem:cart:updated', { detail: cart }));
      })
      .catch(function () {});
  }

  // Trigger: bag icon button click — capture phase beats Dawn's event delegation
  if (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      openDrawer();
    }, true);
  }

  // Close: X button or backdrop click
  if (closeBtn)  closeBtn.addEventListener('click', closeDrawer);
  if (backdrop)  backdrop.addEventListener('click', closeDrawer);

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  // Listen for open events dispatched by louis-pdp.js after add-to-cart
  document.addEventListener('tenhem:cart:open', openDrawer);

  } // end initCartDrawer

})();

